import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface IReactionSummaryResponse {
	reactions: string[];
	count: number;
	user_reaction: { reaction: string; name: string } | null;
}

export interface PostReactionSummary {
	total: number;
	byType: Record<string, number>;
}

const fetchPostReactionSummary = async (
	postId: string
): Promise<PostReactionSummary> => {
	const { data } = await cmsClient.get<IReactionSummaryResponse>(
		`/social-posts/${postId}/reactions/`
	);
	const byType: Record<string, number> = {};
	for (const r of data.reactions ?? []) {
		byType[r] = (byType[r] ?? 0) + 1;
	}
	return { total: data.count ?? data.reactions?.length ?? 0, byType };
};

const usePostReactionSummary = (postId: string, enabled: boolean) =>
	useQuery({
		queryKey: ["post-reaction-summary", postId],
		queryFn: () => fetchPostReactionSummary(postId),
		enabled: enabled && Boolean(postId),
		staleTime: 30_000
	});

export default usePostReactionSummary;
